<template>
    <nav v-if="items.length" class="header-crumbs" aria-label="Навигация проекта">
        <div v-for="(item, index) in items" :key="`item-wrap-${index}`" class="crumbs-entry">
            <span v-if="index > 0" :key="`sep-${index}`" class="crumbs-back" aria-hidden="true">←</span>
            <div class="crumbs-item">
                <BreadcrumbsSelector
                    v-if="item.type === 'project'"
                    :items="projectsToGo"
                    :loading="loadingProjects"
                    @open="onProjectSwitcherOpen"
                />
                <router-link
                    v-if="isClickable(item)"
                    class="crumbs-link"
                    :to="item.to"
                >
                    {{ item.text }}
                </router-link>
                <span v-else class="project-name">{{ item.text }}</span>
            </div>
        </div>
    </nav>
</template>

<script>
import { mapState } from 'vuex'
import { useProject } from '@/hooks/useProject'
import BreadcrumbsSelector from '@/components/ui/BreadcrumbsSelector.vue'

export default {
    name: 'HeaderBreadcrumbs',
    components: { BreadcrumbsSelector },
    data: () => ({
        loadingProjects: false,
    }),
    computed: {
        ...mapState(['projects', 'headerBreadcrumbs']),
        items() {
            return this.headerBreadcrumbs || []
        },
        project() {
            const { project } = useProject()
            return project
        },
        projectsToGo() {
            return (
                this.projects
                    ?.map(p => ({ value: p.id, name: p.name }))
                    .filter(p => p.value !== this.project?.value?.id) || []
            )
        },
    },
    methods: {
        isClickable(item) {
            return !!item?.to && !item?.disabled
        },
        async onProjectSwitcherOpen() {
            if (this.$store.state.project?.areAllProjectsLoaded || this.loadingProjects) {
                return
            }
            this.loadingProjects = true
            try {
                await this.$store.dispatch('project/setProjects', { silent: true })
            } finally {
                this.loadingProjects = false
            }
        },
    },
}
</script>

<style lang="sass" scoped>
.header-crumbs
    min-width: 0
    max-width: 100%
    flex: 1 1 auto
    display: flex
    align-items: center
    gap: 8px
    overflow: visible
    color: rgba(255, 255, 255, .62)
    font-size: 11.5px
    font-weight: 700
    line-height: 1
    letter-spacing: .04em
    text-transform: uppercase
    white-space: nowrap

.crumbs-item
    min-width: 0
    display: inline-flex
    align-items: center
    gap: 6px
    overflow: visible

.crumbs-entry
    min-width: 0
    display: inline-flex
    align-items: center
    gap: 8px

.crumbs-link
    min-width: 0
    max-width: 100%
    color: rgba(255, 255, 255, .78) !important
    transition: color .15s ease
    text-decoration: none
    overflow: hidden
    text-overflow: ellipsis

    &:hover
        color: #fff !important

.crumbs-back
    flex: 0 0 auto
    color: rgba(255, 255, 255, .42)
    font-size: 13px
    transform: translateY(-1px)

.project-name
    overflow: hidden
    max-width: 100%
    color: #fff
    font-weight: 800
    text-overflow: ellipsis

@media (max-width: 980px)
    .header-crumbs > .crumbs-entry:first-child .crumbs-item,
    .header-crumbs > .crumbs-entry:first-child .crumbs-back
        display: none
    .header-crumbs > .crumbs-entry:nth-child(2) .crumbs-back
        display: none

@media (max-width: 760px)
    .header-crumbs
        display: block
        flex: 1 1 auto
        min-width: 0
        max-width: 100%
        overflow: hidden
        font-size: 12px
        line-height: 1.2
        letter-spacing: 0
        text-transform: none

    .crumbs-entry
        min-width: 0
        max-width: 100%
        overflow: hidden

    .crumbs-item
        min-width: 0
        max-width: 100%
        overflow: hidden

    .crumbs-link,
    .project-name
        display: block
        max-width: 100%
        overflow: hidden
        white-space: nowrap
        text-overflow: ellipsis
        font-size: 12px
        font-weight: 800

@media (max-width: 430px)
    .crumbs-link,
    .project-name
        font-size: 11.5px

@media (max-width: 380px)
    .crumbs-link,
    .project-name
        font-size: 11px
</style>
